import MasterService from './../../../services/masterdata.service';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import XLSX from 'xlsx';
import Papa from "papaparse";

export default {
  name: 'create-service-level-template',
  components: {
    VueElementLoading,
    CustomExpandableTable,
    Pagination,
  },
  props: ["selectedEditRowData"],
  data: function() {
    return {
      isLoading:false,
      file:null,
      filename:null,
      disabled: false,
      seriveLevelTemplateName: '',
      serviceLevelTemplateDescription: '',
      RouteMode: 'Surface',
      selectedTemplate: {
        id: null,
        label: ''
      },
      serviceLevelId:null,
      totalrecords:0,
      validdata:[],
      validdatacount:0,
      invaliddata:[],
      invaliddatacount:0,
      tatpincodelist:[],
      opstatlist:"",
      salestatlist:[],
      isupload:0,
      totalPage:0,
      totalCount:0,
      offset: 1,
      filedata : "",
      pageLimit:200,
      currentPage: 1,
      tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
      'Destination Region','Destination State','Destination City',
      'Route Mode','E2E TAT','Invalid Reason'],
      tableItems: [],
      showSalesTatDownload: false,
      userid:"",
      userreferencestring: "",
      servicetype : 2,
      filesource : '../static/Reliance-format.csv',
      arrOfMatrix : [],
      invalid18x18Data : [],
      zones:[]
    }
  },
  computed: {
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.email = userdetail.email;
    this.userid = userdetail.userid;
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let text = "";
    await this.getZonenamesdata()
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    let uniquerefno = this.userid+text;
    this.userreferencestring = uniquerefno;
    if(this.selectedEditRowData){
      this.seriveLevelTemplateName=this.selectedEditRowData.servicelevelname;
      this.serviceLevelTemplateDescription = this.selectedEditRowData.serviceleveldescription;
      this.RouteMode = this.selectedEditRowData.routemode;
      this.servicetype = this.selectedEditRowData.servicetype;
      if(this.selectedEditRowData.id){
        this.serviceLevelId = this.selectedEditRowData.id;
        this.showSalesTatDownload = true;
      }
    } else {
      this.seriveLevelTemplateName="";
      this.serviceLevelTemplateDescription = "";
      this.selectedTemplate= {
        id: null,
        label: ''
      }
    }
  },
  methods: {
    showList() {
      this.$emit("goBackToParent");
    },
    ClearForm(){
      this.isupload = 0;
      this.validdatacount = 0;
      this.invaliddatacount = 0;
      this.totalrecords = 0;
      this.filename = null;
      this.filedata = [];
      this.salestatlist = [];
      this.showSalesTatDownload = false;
    },
    async getServiceLevelDetails(){
      try {
        this.salestatlist = [];
        this.isLoading = true;
        let payload = {
          servicelevelid: this.serviceLevelId
        }
        let countResult = await MasterService.getServiceLevelCount(payload);
        let serviceTemplateCount = Number(countResult.data.data);
        let limit = 30000;
        let offset = 0;
        let tatlist = [];
        let loop =  Math.ceil(serviceTemplateCount / limit);
        for (let i = 0; i < loop; i++) {
          payload.limit = limit;
          payload.offset = offset;
          let result = await MasterService.getServiceLevelDetail(payload);   
          offset = offset + limit;
          tatlist = tatlist.concat(result.data.data.rows)
        }
        let temparr = [];
        tatlist.forEach((item)=>{
          temparr.push({
               "Origin Region":item.originregion,
               "Origin State":item.originstate,
               "Origin City":item.origincity,
               "Destination Region":item.destinationregion,
               "Destination State":item.destinationstate,
               "Destination City":item.destinationcity,
               "Route Mode":item.travelmode,
               "E2E TAT":parseInt(item.tat)
             });
        });
        this.salestatlist = temparr;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async downloadOpsTATMaster() {
      try {
        this.isLoading = true;
        let result = await MasterService.getOpsTATlist();
        let tatlist = result.data.data;
        var link = document.createElement('a');
        link.href = tatlist;
        link.setAttribute('target','_blank');
        window.open(tatlist, '_blank');
        link.remove();
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async downloadPincodeMaster(){
      try {
        let promiseResult = [];
        let pagelimit = 200;
        let temparr = [];
        this.isLoading = true;
        let inputPayloadCargoPickup = {
          "offset": 1,
          "limit": 10,
          "businessunit":"Cargo",
          "businessservice":"PickUp"
        }
        let inputPayloadCargoDelivery = {
          "offset": 1,
          "limit": 10,
          "businessunit":"Cargo",
          "businessservice":"Delivery"
        }
        let inputPayloadCargoAirPickup = {
          "offset": 1,
          "limit": 10,
          "businessunit":"CargoAir",
          "businessservice":"PickUp"
        }
        let inputPayloadCargoAirDelivery = {
          "offset": 1,
          "limit": 10,
          "businessunit":"CargoAir",
          "businessservice":"Delivery"
        }
        //get pincode list
        promiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoPickup));
        promiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoDelivery));
        promiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoAirPickup));
        promiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoAirDelivery));
        let newResult = await Promise.all(promiseResult);

        let totalpagecountCargoPickup = Math.ceil(newResult[0].data.data.count/pagelimit);
        let totalpagecountCargoDelivery = Math.ceil(newResult[1].data.data.count/pagelimit);
        let totalpagecountCargoAirPickup = Math.ceil(newResult[2].data.data.count/pagelimit);
        let totalpagecountCargoAirDelivery = Math.ceil(newResult[3].data.data.count/pagelimit);

        let newPromiseResult = [];
        for(let i=1; i<=totalpagecountCargoPickup; i++){
          let inputPayloadCargoPickup1 = {
            "offset": i,
            "limit": pagelimit,
            "businessunit":"Cargo",
            "businessservice":"PickUp"
          }
          newPromiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoPickup1));
        }

        for(let i=1; i<=totalpagecountCargoDelivery; i++){
          let inputPayloadCargoDelivery1 = {
            "offset": i,
            "limit": pagelimit,
            "businessunit":"Cargo",
            "businessservice":"Delivery"
          }
          newPromiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoDelivery1));
        }
        for(let i=1; i<=totalpagecountCargoAirPickup; i++){
          let inputPayloadCargoAirPickup1 = {
            "offset": i,
            "limit": pagelimit,
            "businessunit":"CargoAir",
            "businessservice":"PickUp"
          }
          newPromiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoAirPickup1));
        }
        for(let i=1; i<=totalpagecountCargoAirDelivery; i++){
          let inputPayloadCargoAirDelivery1 = {
            "offset": i,
            "limit": pagelimit,
            "businessunit":"CargoAir",
            "businessservice":"Delivery"
          }
          newPromiseResult.push(MasterService.getTATPincodelist(inputPayloadCargoAirDelivery1));
        }
        let newResult1 = await Promise.all(newPromiseResult);
        for(let k=0; k<newResult1.length; k++){
          let pincodelist1 = newResult1[k].data.data.data;
          pincodelist1.forEach((item)=>{
            temparr.push({
              "Branch Name":item.HubName,
              "Branch Pincode":item.HubPincode,
              "Branch ID":item.HubID,
              "Pincode mapped":item.hubmappincode,
              "Pincode Type":item.pincodetype,
              "Region":item.region,
              "City":item.cityname,
              "State":item.statename,
              'Business Unit' : item.businessunit,
              'Business Service' : item.businessservice
            });
          });
        }
        this.tatpincodelist = temparr;
        var blob = new Blob([Papa.unparse(temparr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'Pin Code Master.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async downloadSalesTAT(){
      try {
        this.isLoading = true;
        await this.getServiceLevelDetails();
        var blob = new Blob([Papa.unparse(this.salestatlist)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'Sales TAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async downloadSalesTATZoneToZone() {
      try {
        this.isLoading = true;
        let payload = {
          servicelevelid: this.serviceLevelId,
          servicetype: "2"
        }
        let result = await MasterService.GetZoneToZoneDataFOrDownload(payload);
        let xlsdata = this.createMatrixforZonetoZone(result.data.data.rows)
        var blob = new Blob([Papa.unparse(xlsdata)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "Sales TAT (Zone To Zone).csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
     createMatrixforZonetoZone(data) {
      const matrix = {};
      const matrixArray = this.zones.map((origin) => {
        const row = { '': origin };
        this.zones.forEach((destination) => {
          const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
          row[destination] = foundItem ? foundItem.tat : null;
        });
        return row;
      });
      return matrixArray;
    },
    async resetFile(){
      this.$refs.files.value=null;
    },
    async chooseFile(e){
      try {
        this.isupload = 0;
        this.validdata = [];
        this.invaliddata = [];
        this.salestatlist = [];
        this.showSalesTatDownload = false;
        const files = e.target.files;
        if (!files.length) {
          this.$refs.files.value=null;
          return;
        } else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
          this.$refs.files.value=null;
          return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
        }else{
          this.filename = e.target.files[0].name;
          this.file = e.target.files[0];
          await this.parseFile();
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async parseFile(){
      let userid = this.userid;
      let userreferencestring = this.userreferencestring;
      var count = 0; // cache the running count
      var csvData=[];
      var sheetid = 1;
      var validheader = 1;
      Papa.parse( this.file, {
          header: true,
          skipEmptyLines: true,
          before: this.isLoading = true,
          worker: true, // Don't bog down the main thread if its a big file
          step: function(result) {
            let fileHeaders = result.meta.fields;
            if(sheetid==1 && !fileHeaders.includes("Origin Region") ||
              !fileHeaders.includes("Origin State") ||
              !fileHeaders.includes("Origin City") ||
              !fileHeaders.includes("Destination Region") ||
              !fileHeaders.includes("Destination State") ||
              !fileHeaders.includes("Destination City") ||
              !fileHeaders.includes("Route Mode") ||
              !fileHeaders.includes("E2E TAT")){
                this.filedata = [];
                this.filename=null;
                validheader = 0;
            }
            sheetid ++;
            let tempResult = {};
              tempResult.originregion = (result.data['Origin Region'])?result.data['Origin Region']:null;
              tempResult.originstate = (result.data['Origin State'])?result.data['Origin State']:null;
              tempResult.origincity = (result.data['Origin City'])?result.data['Origin City']:null;
              tempResult.destinationregion = (result.data['Destination Region'])?result.data['Destination Region']:null;
              tempResult.destinationstate = (result.data['Destination State'])?result.data['Destination State']:null;
              tempResult.destinationcity = (result.data['Destination City'])?result.data['Destination City']:null;
              tempResult.travelmode = (result.data['Route Mode'])?result.data['Route Mode']:null;
              tempResult.feedertat = (result.data['E2E TAT'])?result.data['E2E TAT']:null;
              tempResult.status = 0;
              tempResult.userid = userid;
              tempResult.userreferencestring = userreferencestring;
              tempResult.sheetid = sheetid;
              csvData.push(tempResult);
          }.bind(this),
          complete: function(){
            if(validheader==0){
              this.isLoading = false;
              this.filedata = [];
              this.filename = null;
              return this.$alert('File headers are not matched. Please download OPS TAT csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
            }else if(csvData.length<1){
              this.isLoading = false;
              this.filedata = [];
              this.filename = null;
              return this.$alert('Sales TAT file data should not be blank. At least one record set is required.', "", "error");
            }else{
              this.filedata = csvData;
              this.totalrecords = csvData.length;
              this.chunkArray(this.filedata, 20000);
            }
          }.bind(this)
      } );
      this.isLoading = false
    },
    async chunkArray(myArray, chunk_size){
      try {
        await this.deletePreviousUploadSalesTAT();
        var index = 0;
        var arrayLength = myArray.length;
        let tempArr = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            await this.uploadSalesFile(myChunk, index);
        }
        this.$alertify.success("File data uploaded Successfully");
        this.isLoading = false;
      }catch (err){
        console.log(err);
      }
    },
    async deletePreviousUploadSalesTAT(){
      try{
        this.isLoading = true;
        var inputPayload = {};
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.deletePreviousUploadSalesTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
    async uploadSalesFile(filechunkdata, index){
      try{
        var inputPayload = {};
        for (let i = 0; i < filechunkdata.length; i++) {
          filechunkdata[i].servicetype = 1
        }
        inputPayload.file = filechunkdata;
        let result = await MasterService.uploadSalesTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
    async validateFile(){
      try {
        this.isLoading = true;
        var inputPayload = {};
        inputPayload.routemode = this.RouteMode;
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.validateSalesTAT(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.isupload = 1;
          let resultData = result.data.data;
          let successCount = 0;
          let failedCount = 0;
          resultData.forEach((element) => {
              if(element.status==1){
                successCount = element.count;
              }
              if(element.status==2){
                failedCount = element.count;
              }
          });
          this.validdatacount = successCount;
          this.invaliddatacount = failedCount;
          if(this.invaliddatacount > 0){
            this.getInvalidDataListing();
          }
        }else{
          this.isupload = 0;
          this.validdatacount = 0;
          this.invaliddatacount = 0;
          this.$alert(result.data.message,this.seriveLevelTemplateName, "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getInvalidDataListing(){
      try {
        this.isLoading = true;
        this.tableItems = [];
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.getInvalidSalesTATListing(inputPayload);
        this.totalCount = result.data.data.count;
        this.totalPage = Math.ceil(this.totalCount/this.pageLimit);
        this.invaliddata = result.data.data.rows;
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id':el.id,
            'Sheet Row Number':el.sheetid,
            'Origin Region':el.originregion,
            'Origin State': el.originstate,
            'Origin City':el.origincity,
            'Destination Region':el.destinationregion,
            'Destination State':el.destinationstate,
            'Destination City':el.destinationcity,
            'Route Mode':el.travelmode,
            'E2E TAT':el.feedertat,
            'Invalid Reason':el.comment
          }
        })
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit;
      this.getInvalidDataListing();
    },
    confirmServiceLevelDataUpdate(){
      this.$validator.validateAll().then((result) => {
				if (result) {
          if(this.serviceLevelId){
            let WarningMsg = "The old data will be overwritten by new data.Are you sure?";
            this.$confirm(WarningMsg,"","question").then(()=>{
              this.saveServiceLevelData();
            }).catch((err)=>{
              console.log(err);
            });
          }else{
            this.saveServiceLevelData();
          }
				}
			}).catch((err) => {
				console.log('errors exist', err);
			});
    },
    async saveServiceLevelData(){
      try {
        let postData = {
          servicelevelname : this.seriveLevelTemplateName.trim(),
          serviceleveldescription:this.serviceLevelTemplateDescription.trim(),
          routemode: this.RouteMode,
          createdby:this.email,
          lastmodifiedby:this.email,
          servicetype :this.servicetype
        };
        if (this.servicetype == 1) {
          postData.userid = this.userid;
          postData.userreferencestring = this.userreferencestring;
        }else if(this.servicetype == 2 ){
          postData.arrOfMatrix = this.arrOfMatrix
        }

        if(this.serviceLevelId){
          postData.servicelevelid = this.serviceLevelId;
        }
        this.isLoading = true;
        let result = await MasterService.saveServiceLevelTemplate(postData);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.seriveLevelTemplateName, "success");
          this.$emit("goBackToParent");
        } else {
          this.$alert(result.data.message,this.seriveLevelTemplateName, "error");
        }
      } catch (err) {
        this.isLoading = false;
        this.$alert("Service Level Template Name Already Exists.",this.seriveLevelTemplateName, "error");
      }
    },
    async downloadInvalidData(){
      try {
        this.isLoading = true;
        let inputPayload = {};
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.getInvalidSalesTATForDownload(inputPayload);
        let invaliddataResult = result.data.data.rows;
        let tempData = [];
        invaliddataResult.forEach((item)=>{
          tempData.push({
               "Sheet Row Number": item.sheetid,
               "Origin Region":item.originregion,
               "Origin State":item.originstate,
               "Origin City":item.origincity,
               "Destination Region":item.destinationregion,
               "Destination State":item.destinationstate,
               "Destination City":item.destinationcity,
               "Route Mode":item.travelmode,
               "E2E TAT":item.feedertat,
               "Invalid Reason": item.comment
             });
        });
        var blob = new Blob([Papa.unparse(tempData)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'Invalid Sales TAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    download18x18Template(){
      this.isLoading = true;
      let resultArr=[]
        let downloadArr=this.createMatrixforZonetoZone(resultArr)
        var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'SalesTAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
    },
    async choose18x18File(e){
      try {
        this.isupload = 0;
        this.validdata = [];
        this.invaliddata = [];
        this.invalid18x18Data = []
        this.salestatlist = [];
        this.invaliddatacount = 0
        this.validdatacount = 0
        this.totalrecords = 0
        this.showSalesTatDownload = false;
        const files = e.target.files;
        if (!files.length) {
          this.$refs.files18x18.value=null;
          return;
        } else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
          this.$refs.files.value=null;
          return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
        }else{
          this.filename = e.target.files[0].name;
          this.file = e.target.files[0];
          await this.parse18x18File();
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
     parse18x18File(){
      let tempArr = []
      Papa.parse(this.file, {
        before: this.isLoading = true,
        header: true, // Assumes the first row contains column headers
        skipEmptyLines: true,
        dynamicTyping: true, // Automatically convert values to their appropriate types
        complete: function (result) {
          console.log("result.errors",result.errors);
          let data = result.data;
          // Create an object to store the JSON data
          // Iterate through the rows and columns to create the JSON
          console.log("data",data);
          if (data.length>18) {
            return this.$alert('Invalid 18 x18 template :File headers mismached Origin Zones shold be maximum 18', "", "error");
          }
          let duplicaterow = this.hasDuplicateEmptyValues(data)
          if (duplicaterow) {
            return this.$alert('File headers are duplicate. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
          }
          for (let i = 0; i < data.length; i++) {
            let row = data[i];
            let rowName = row['']; // Row name is in the first column  
            console.log(row);
            if(Object.keys(row).length>19)
              {
                return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
              }
              if(Object.keys(row)[0] )
              {
                  this.isLoading = false
                  return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
              }
              if(  !this.zones.includes(rowName))
              {

                this.isLoading = false
               let errMsg= `Origin Zone ${rowName} is invalid`
                return this.$alert(errMsg, "", "error");
              }
            for (const colName in row) {
              const keysArray = Object.keys(row);
               if( keysArray.indexOf(colName)!=0 && !this.zones.includes(colName))
              {
                this.isLoading = false
                return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
              }
              if (colName !== '' && row[colName]!= null) {
                let zoneName = colName;
                tempArr.push({originzone : rowName , destinationzone :zoneName , TAT : row[colName] })
              }
            }
          }
          // Convert the JSON data to a JSON string
        }.bind(this)
      });
      this.arrOfMatrix = tempArr
      this.isLoading = false
    },
    async validate18x18File(){
      try {
        this.isLoading = true;
        var inputPayload = {};
        // console.log("this.json18x18",this.json18x18);
        inputPayload.arrOfMatrix = this.arrOfMatrix;
        this.totalrecords = this.arrOfMatrix.length;
        let result = await MasterService.validateSalesTAT18x18(inputPayload);
        this.isupload = 1
        this.isLoading = false;
        if (result.data.code == 200) {
          this.invaliddatacount = 0
          this.validdatacount = this.totalrecords
          if(  this.validdatacount==0)
          {
           this.$alert('Please upload file with data', "", "error");
          }
          else{
          this.$alertify.success("File data validated Successfully");
          }
        }else{
          this.invalid18x18Data = result.data.data
          this.invaliddatacount = this.invalid18x18Data.length
          this.validdatacount = this.totalrecords - this.invaliddatacount
          this.$alertify.success("File data validated Successfully");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getZonenamesdata() {
      let inputpayload = {}
      let result = await MasterService.GetZoneNames(inputpayload);
      if (result.data.code == 200) {
        this.zones = result.data.data
      }
      else {
        this.$alertify.success("Zones Data not found");
      }
    },
     hasDuplicateEmptyValues(arr) {
      const seenValues = new Set();
    
      for (const obj of arr) {
        const value = obj[""];
    
        if (seenValues.has(value)) {
          // Duplicate value found
          return true;
        } else {
          // Add the value to the set
          seenValues.add(value);
        }
      }
    
      // No duplicate values found
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ServiceLevelTemplate/CreateServiceLevel/CreateServiceLevel.component.js